import { SET_VIEW_TRANSACTION_BIDS } from "../action.js";

export const setViewTransactionBids = (bids) => {
  return (dispatch) => {
    dispatch({ type: SET_VIEW_TRANSACTION_BIDS, payload: bids });
  };
};
